export interface StoryboardOutlineEntry {
  key: string;
  sceneId: string;
  shotId: string;
  sceneIndex: number;
  shotIndex: number;
  sceneTitle: string;
  title: string;
  source: string;
  image?: string;
}

export function storyboardOutline(scenes: Array<Record<string, unknown>>): StoryboardOutlineEntry[] {
  return scenes.flatMap((scene, sceneIndex) => {
    const sceneId = String(scene.id || 'scene_' + (sceneIndex + 1));
    const sceneTitle = String(scene.title || sceneId);
    const shots = (Array.isArray(scene.shots) ? scene.shots : []) as Array<Record<string, unknown>>;
    if (!shots.length) return [{ key: JSON.stringify([sceneId, '']), sceneId, shotId: '', sceneIndex, shotIndex: -1, sceneTitle, title: '尚无镜头', source: '' }];
    return shots.map((shot, shotIndex) => {
      const shotId = String(shot.id || sceneId + '_shot_' + (shotIndex + 1));
      return { key: JSON.stringify([sceneId, shotId]), sceneId, shotId, sceneIndex, shotIndex, sceneTitle,
        title: String(shot.title || '镜头 ' + (shotIndex + 1)),
        source: String(shot.source_text || shot.source_excerpt || ''),
        image: typeof shot.keyframe_url === 'string' ? shot.keyframe_url : undefined };
    });
  });
}

export function focusedStoryboardEntry(entries: StoryboardOutlineEntry[], key: string): StoryboardOutlineEntry | undefined {
  const current = entries.find(entry => entry.key === key);
  if (current) return current;
  let sceneId: unknown;
  try { sceneId = JSON.parse(key)?.[0]; } catch { sceneId = undefined; }
  return entries.find(entry => entry.sceneId === sceneId) || entries[0];
}
